import { ISignupForm } from 'utils/form/types';

import { ModalAuthHook } from './hooks/use-modal-auth';

export interface IAuthRouteParams {
  showOtpForm?: boolean;
  activeRouteIsSignIn?: boolean;
  attemptedSignUpWithExistingEmail?: boolean;
  hasSignedOut?: boolean;
  errorMessage?: string;
  triggerSignInAccessibility?: boolean;
  email?: string;
  currentTabKey?: string;
}

export type UpdateUserInfoOptions = {
  shouldThrowException?: boolean;
  shouldMuteUserInfoErrors?: boolean;
};

export enum ModalAuthScreen {
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  CHALLENGE = 'challenge',
  CLOSED = 'closed',
}

export type ModalAuthState = {
  screen?: ModalAuthScreen;
  errorMessage?: string;
  user?: Partial<Pick<ISignupForm, 'email' | 'name'>>;
  loginForVendorIsLoading?: boolean;
  disableEmailInput?: boolean;
  heading?: string;
  onClose?: () => void;
  onPreSignIn?: () => void | Promise<void>;
  onSignInSuccess?: ModalAuthHook['onSignInSuccess'];
  shouldDisplaySignInSuccessMessage?: boolean;
  shouldWaitLoginForVendor?: boolean;
  shouldDisableHeadlineLinks?: boolean;
};
